/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Réponse générique pour les opérations
 * @export
 * @interface OperationResponse
 */
export interface OperationResponse {
    /**
     * Indique si l'opération a réussi
     * @type {boolean}
     * @memberof OperationResponse
     */
    isSuccess?: boolean;
    /**
     * Message de retour (succès ou erreur)
     * @type {string}
     * @memberof OperationResponse
     */
    message?: string | null;
    /**
     * Message d'erreur détaillé en cas d'échec
     * @type {string}
     * @memberof OperationResponse
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the OperationResponse interface.
 */
export function instanceOfOperationResponse(value: object): value is OperationResponse {
    return true;
}

export function OperationResponseFromJSON(json: any): OperationResponse {
    return OperationResponseFromJSONTyped(json, false);
}

export function OperationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function OperationResponseToJSON(json: any): OperationResponse {
    return OperationResponseToJSONTyped(json, false);
}

export function OperationResponseToJSONTyped(value?: OperationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'message': value['message'],
        'errorMessage': value['errorMessage'],
    };
}

